@if (control(); as control) {
  @if (field(); as field) {
    <div fxFlex fxLayout="column" fxLayoutGap="10px" class="iot-platform-ui-form-field__toggle-container">
      <mat-slide-toggle
        [formControl]="control"
        data-cy="iot-platform-ui-toggle-input"
        class="iot-platform-ui-form-field--{{ field.name?.() }} {{ field.inputCssClassName?.() }}"
        [fxFlex]="field.fxFlexOption?.() ? '0 1 calc(' + $safeNavigationMigration(field.fxFlexOption?.()) + ' - 10px)' : 'auto'"
        [fxFlex.lt-sm]="'100%'"
        (change)="field.selectionChange?.($event)"
        (click)="field.onClick?.($event)"
        [disabled]="$safeNavigationMigration(field.disabled?.())"
        [ngClass]="{ 'capitalize-first-letter': $safeNavigationMigration(field.capitalized?.()) }"
        color="accent"
      >
        {{ $safeNavigationMigration(field.label?.()) | translate }}
      </mat-slide-toggle>

      @if (control?.invalid && control?.hasError('required')) {
        <mat-error class="fs-8">{{ 'FORM.ERROR_MESSAGE.REQUIRED' | translate }}</mat-error>
      } @else if (control?.invalid && field.error?.enabled?.() && field.error?.message?.()) {
        <mat-error class="fs-8">{{ $safeNavigationMigration(field.error?.message?.()) | translate }}</mat-error>
      }

      @if (field.hint?.()?.type?.() === FormControlHintType.TEXT) {
        <span class="fs-12">
          {{ $safeNavigationMigration(field.hint?.()?.text?.()) | translate }}
        </span>
      }
    </div>
  }
}
